import { NgModule } from '@angular/core';
import {
  AtomsModule,
  LayoutModule,
  TypographyModule,
} from '@onafriq/design-system';

@NgModule({
  exports: [AtomsModule, LayoutModule, TypographyModule],
})
export class OnafriqModule {}
